import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  data: object | object[];
}

export const StructuredData = ({ data }: StructuredDataProps) => {
  const dataArray = Array.isArray(data) ? data : [data];
  
  return (
    <Helmet>
      {dataArray.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

// Predefined schemas for common use cases
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Renest",
  "url": "https://renest.fr",
  "logo": "https://storage.googleapis.com/gpt-engineer-file-uploads/FPQyAIjkMUPwgNdomDZ7IMGUxuz2/uploads/1758480594028-Renest.png",
  "description": "Plateforme de gestion du télétravail international et des workations pour entreprises",
  "sameAs": []
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Renest",
  "url": "https://renest.fr",
  "description": "Télétravail international et workation pour entreprises"
};

export const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Renest",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "description": "Plateforme SaaS pour gérer le télétravail international, les workations et les visas des employés",
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "EUR",
    "description": "Essai gratuit disponible"
  }
};
